import cn from 'clsx'

import { type FeatureList as FeatureListType } from '../../../../../apps/benmax/src/types/sanity.types'

import { Copy } from 'shared-components'

import Tick from '../../../images/tick'

import s from './FeatureList.module.sass'

type ExtendedFeatureListType = FeatureListType & {
    site: string
}

function FeatureList({ title, copy, features, hideBottomLine }: ExtendedFeatureListType) {
    return (
        <section className={cn(s.FeatureList, hideBottomLine ? s.HideBottomLine : '')}>
            <div className={cn(s.Cont, 'container')}>
                {(title || copy) && (
                    <div className={s.Intro}>
                        {title && <h2 className={s.Title}>{title}</h2>}
                        {copy && (
                            <div className={s.Copy}>
                                <Copy copy={copy} />
                            </div>
                        )}
                    </div>
                )}
                {features && (
                    <div className={s.Features}>
                        {features.map((feature, i) => {
                            const { title, copy } = feature

                            return (
                                <div key={i} className={s.Feature}>
                                    <div>
                                        {Tick}
                                        <div className={s.FeatureContent}>
                                            {title && <h5 className={s.FeatureTitle}>{title}</h5>}
                                            {copy && (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: copy,
                                                    }}
                                                    className={s.FeatureCopy}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </section>
    )
}

export default FeatureList
